import type { ReactElement, ReactNode } from 'react'

import { Heading } from '@orus.eu/pharaoh-next/components/ui/heading'
import { Text } from '@orus.eu/pharaoh-next/components/ui/text'

import { PharaohNextScope } from '#/lib/pharaoh-next/pharaoh-next-scope.tsx'

type AiPageFrameProps = {
  title: string
  titleAdornment?: ReactNode
  subtitle?: string
  actions?: ReactNode
  tabs?: ReactNode
  back?: ReactNode
  children: ReactNode
}

export function AiPageFrame({
  title,
  titleAdornment,
  subtitle,
  actions,
  tabs,
  back,
  children,
}: AiPageFrameProps): ReactElement {
  return (
    <PharaohNextScope surface="bo">
      <div className="flex min-h-full w-full flex-col">
        <div className="sticky top-0 z-2 border-b border-solid border-line-base-basic bg-surface-base-normal px-60 py-50">
          <header className="flex min-h-[40px] items-center justify-between gap-inline">
            <div className="flex min-w-0 items-center gap-stack">
              {back}
              {/* Level, not size: every `Section.Title` under here is an `<h2>`, so the page title has to be the h1. */}
              <Heading variant="h6" level={1}>
                {title}
              </Heading>
              {titleAdornment}
            </div>
            {actions ? <div className="flex items-center gap-inline">{actions}</div> : null}
          </header>
        </div>

        <div className="flex flex-col gap-stack px-60 py-50">
          {subtitle ? (
            <Text variant="body2" className="text-content-base-basic">
              {subtitle}
            </Text>
          ) : null}

          {tabs}

          {children}
        </div>
      </div>
    </PharaohNextScope>
  )
}
